const doc = [({"da":({"js":({"admin":({"show_boxes":({"form":({"the_show_box_was_saved":"Visningsboksen blev gemt."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;